import React from 'react';
import { ChatMessage, Text, Link } from 'pcln-design-system';
import { TravelBotLogoImage } from '../../TravelBotLogoImage';
import MessageFooter from '../MessageFooter/MessageFooter';
export default function DisplayFeedbackMarker({
  message,
  surveyLink,
  anchorMessage
}) {
  return React.createElement(ChatMessage, {
    ml: '',
    mb: '8px',
    variation: 'initial',
    Icon: TravelBotLogoImage,
    message: React.createElement(React.Fragment, null, React.createElement(Text, null, message, React.createElement(Link, {
      href: surveyLink,
      target: '_blank'
    }, "\u00A0", anchorMessage))),
    footer: React.createElement(MessageFooter, null)
  });
}